import { portfolioIntelligenceContent } from '@/config/marketing-content/feature-pages'
import { FeatureMarketingPage } from '@/components/marketing/feature-marketing-page'

export function PortfolioIntelligencePage() {
  return <FeatureMarketingPage content={portfolioIntelligenceContent} />
}
